export default __webpack_public_path__ + "static/media/article_no_image.8f96e589.svg";